import { SocialMediaContext } from 'context/SocialMediaContext';
import { useContext } from 'react';

const useSocialMediaContext = () => {
  return { ...useContext(SocialMediaContext) };
};

export default useSocialMediaContext;
